var Vendd = (function (Vendd) {
    'use strict';

	var pending = false;

	Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModel, Vendd.UserWishlist, function (envelope) {

	    if (pending === true) {
	        return false;
	    };

	    function onSuccess(response) {
	        model = response.data ? $.extend({}, response.data, { LangCode: LhApp.Context.Language }) : response.data;
	        Vendd.UserWishlist.SetClientModel(model);
	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.GetModelSuccess(model));

	        pending = false;
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.GetModelFailed(response));
	    }

	    var options = {
	        method: 'GET',
	        url: 'api/Wishlist/GetUserWishlists' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    if (model != null && model != undefined && Vendd.UserWishlist.GetClientModel() != null && document.cookie.indexOf('ForceClearUserWishlistsLocalStorage') == -1 && LhApp.Context.Item.Template != "wishlist") {

	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.GetModelSuccess(model));
	        return true;
	    }

	    pending = true;
        Cookies.remove('ForceClearUserWishlistsLocalStorage', { path: '/' });

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.SaveWishlist, Vendd.UserWishlist, function (envelope) {

	    function onSuccess(response) {
	        if (response.success) {
	            Vendd.UserWishlist.ClearClientModel();
	            Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.GetModel());
	            Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.SaveWishlistSuccess());
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.SaveWishlistFailed(response));
	        }
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.SaveWishlistFailed(response.responseJSON));
	    }

	    var options = {
	        method: 'PUT',
	        data: envelope.message.data,
	        url: 'api/Wishlist/SaveWishlist',
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.DeleteWishlist, Vendd.UserWishlist, function (envelope) {

	    function onSuccess(response) {
	        Vendd.UserWishlist.ClearClientModel();
	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.GetModel());
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserWishlist, new Vendd.UserWishlist.Messages.DeleteWishlistFailed(response));
	    }

	    var options = {
	        method: 'DELETE',
	        data: envelope.message.data,
	        url: 'api/Wishlist/DeleteWishlist',
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});


	Vendd.UserWishlist.ClearClientModel = function () {
	    localStorage.removeItem('CurrentUserWishlistModel');
	};

	Vendd.UserWishlist.GetClientModel = function () {
	    var mdl = JSON.parse(localStorage.getItem("CurrentUserWishlistModel"));

	    return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
	};

	Vendd.UserWishlist.SetClientModel = function (mdl) {
	    localStorage.setItem('CurrentUserWishlistModel', JSON.stringify(mdl));
	};

	var model = Vendd.UserWishlist.GetClientModel();

	return Vendd;

})(Vendd || {});